export default __webpack_public_path__ + "static/ely-4-bd732e2cad44fd09d80ace011ab93070.jpg";